import { render, staticRenderFns } from "./ChangeDepartmentWarnDialog.vue?vue&type=template&id=0f5209d6&"
import script from "./ChangeDepartmentWarnDialog.vue?vue&type=script&lang=js&"
export * from "./ChangeDepartmentWarnDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports